
import axios from "axios";

import { API_URL } from "../config/constants";

const END_POINT = `${API_URL}transaction/`

export const getRequests = (status,page) => {
    console.log('status..',status)
    return axios
        .get(`${END_POINT}get-requests?status=${status}&page=${page}`)
        .then((response) => {
            return response;
        }).catch(e => {
            return e?.response;
        });
};

export const handleTransaction = (id, status) => {
    return axios
        .put(`${END_POINT}handle-transaction/${id}`, {
            status
        })
        .then((response) => {
            return response;
        }).catch(e => {
            return e?.response;
        });
};

export const getOneUserTransactions = (id) => {
    const token = localStorage.getItem('jwtToken');
        if (!token) {
            console.log("Token missing!");
            return null;
        }
    console.log('...getOneUserTransactions')
    return axios
        .get(`${END_POINT}get-user-transactions/${id}`,
                 {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
        .then((response) => {
            return response;
        }).catch(e => {
            return e?.response;
        });
};